import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { getLikedlist } from "../services/firebase";
import MovieList from "../components/MovieList";
import { Link } from "react-router-dom";
import "./LikedMovies.scss";

const LikedMovies = () => {
    const [likedlist, setLikedlist] = useState([]);
    const [loadingLikedlist, setLoadingLikedlist] = useState(false);
    const { user, loading } = useAuth();

    useEffect(() => {
        const fetchLikedlist = async () => {
            if (user) {
                try {
                    setLoadingLikedlist(true);
                    const userLikedlist = await getLikedlist(user.uid);
                    setLikedlist(userLikedlist);
                    setLoadingLikedlist(false);
                } catch (error) {
                    console.error("Error fetching likedlist:", error);
                }
            }
        };
        fetchLikedlist();
    }, [user]);
    return (
        <div className="liked_movies layout">
            <h1>LikedMovies</h1>
            {loading ? (
                <p>Loading...</p>
            ) : user ? (
                <div>
                    {loadingLikedlist ? (
                        <p>Loading...</p>
                    ) : (
                        <>
                            {likedlist.length > 0 ? (
                                <MovieList movies={likedlist} />
                            ) : (
                                <p>Your likedlist is empty.</p>
                            )}
                        </>
                    )}
                </div>
            ) : (
                <div>
                    <Link className="signin_link" to="/signin">
                        SignIn
                    </Link>{" "}
                    to see your liked movies
                </div>
            )}
        </div>
    );
};

export default LikedMovies;
